module.exports = __webpack_public_path__ + "static/media/harlem-brownstones-trees-pano.27afa84e.jpg";